import { Button, Container, Form, Result, Text } from "../../components";
import { useNavigate } from "react-router-dom";
import Localization from "../../localization";
import { useApi, useForm } from "../../hooks";
import React, { useState } from "react";
import { AuthApi } from "../../apis";
import { Flex } from "antd";

const Feedback = () => {
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { execute } = useApi();
  const form = useForm();
  const text = Form.useWatch("text", form);

  if (success)
    return (
      <Container
        containerStyle={{ background: "white", height: "calc(100vh - 6.4rem)" }}
      >
        <Result
          status="200"
          title={Localization.feedback_page.success_title}
          subTitle={Localization.feedback_page.success_desc}
          buttons={[
            { title: Localization.general.done, onClick: () => navigate(-1) },
          ]}
        />
      </Container>
    );
  return (
    <Container
      className="m-64-t"
      containerStyle={{ background: "white", height: "calc(100vh - 6.4rem)" }}
    >
      <Text
        lineHeight="normal"
        level={1}
        weight={700}
        children={Localization.feedback_page.title}
      />
      <Text
        className="m-35-t"
        type="secondary"
        children={Localization.feedback_page.desc_0}
      />
      <Text
        className="m-10-t"
        size={15}
        weight={700}
        children={Localization.feedback_page.desc_1}
      />
      <Form
        form={form}
        className="m-25-t"
        fields={[
          {
            outlined: true,
            type: "textarea",
            name: "text",
            placeholder: Localization.placeholder.enter_message,
          },
          {
            face: "checkbox",
            name: "anonymous",
            valuePropName: "checked",
            children: Localization.placeholder.anonymous,
          },
        ]}
      />
      <Flex gap="1rem" className="m-25-t">
        <Button
          type="primary"
          disabled={!text}
          title={Localization.general.send}
          onClick={async () => {
            await form.validateFields();
            await execute(() => AuthApi.feedback(form.getFieldsValue()));
            setSuccess(true);
          }}
        />
        <Button
          title={Localization.general.go_back}
          onClick={() => navigate(-1)}
        />
      </Flex>
    </Container>
  );
};

export default Feedback;
